import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import licenses from './licenses';
import companies from './companies';
import feigcompanies from './feigCompanies';
import user from './user';
import usermanagement from './usermanagement';
import legaltext from './legaltexts';
import registertan from './registertan';
import envconfig from './envconfig';
import apppermission from './apppermissions';
import app from './app';
import { approles } from './approles';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export type Namespaces =
  | 'envconfig'
  | 'licenses'
  | 'companies'
  | 'feigcompanies'
  | 'user'
  | 'usermanagement'
  | 'legaltext'
  | 'registertan'
  | 'apppermission'
  | 'app';

export default new Vuex.Store({
  modules: {
    envconfig,
    licenses,
    companies,
    feigcompanies,
    user,
    usermanagement,
    legaltext,
    registertan,
    apppermission,
    app,
    approles,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});


